import "./index762.mjs";
import { h as i } from "./index811.mjs";
import { w as p } from "./index760.mjs";
import { __exports as a } from "./index765.mjs";
var f = a.f, m = i, s = p, r = s("toStringTag"), y = function(o, n, e) {
  o && !e && (o = o.prototype), o && !m(o, r) && f(o, r, { configurable: !0, value: n });
};
export {
  y as s
};
